import React, { useCallback, useMemo } from 'react';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { Tooltip } from 'antd';
import { getDocumentIconByDocumentName } from 'functions/formatters/DocumentIcon';
// import colors from 'styles/_colors.scss';

interface IProps
{
	document: IDocument,
	onClick: (doc: IDocument) => void,
	tooltip?: string
}

function DocumentButton(props: IProps)
{
	const onClick = useCallback(() =>
	{
		props.onClick(props.document);
	}, [props]);

	const documentIcon = useMemo(() =>
	{
		return getDocumentIconByDocumentName(props.document.originalFileName);
	}, [props.document]);

	const mainComponent = useMemo(() =>
	{
		return (
			<div className="document-button document-button--grid txt-center" tabIndex={-1} onClick={onClick}>
				{documentIcon}
				<div className="document-name">{props.document.originalFileName}</div>
			</div>
		);
	}, [props.document, onClick, documentIcon]);

	if (props.tooltip) {
		return (
			<Tooltip title={props.tooltip}>
				{mainComponent}
			</Tooltip>
		);
	}

	return mainComponent;
};

export default DocumentButton;